import { ref, watch, computed } from '@vue/composition-api'
import store from '@/store'
import i18n from '@/libs/i18n'

// Notification
import { useToast } from 'vue-toastification/composition'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'

export default function useDtcList() {
  const toast = useToast()

  const refDtcListTable = ref(null)

  const tableColumns = [
    { key: 'name', label: i18n.t('Nome'), sortable: false },
    { key: 'description', label: i18n.t('Descrição'), sortable: false },
    { key: 'itemCount', label: i18n.t('Itens'), sortable: false },
    { key: 'applicationCount', label: i18n.t('Modelos'), sortable: false },
    { key: 'created', label: i18n.t('Criado em'), sortable: false },
    { key: 'actions', label: i18n.t('Ações') },
  ]

  const perPage = ref(10)
  const totalItems = ref(0)
  const currentPage = ref(1)
  const perPageOptions = [10, 25, 50, 100]
  const searchQuery = ref('')
  const isLoading = ref(false)

  const dataMeta = computed(() => {
    const localItemsCount = refDtcListTable.value ? refDtcListTable.value.localItems.length : 0
    return {
      from: perPage.value * (currentPage.value - 1) + (localItemsCount ? 1 : 0),
      to: perPage.value * (currentPage.value - 1) + localItemsCount,
      of: totalItems.value,
    }
  })

  const refetchData = () => {
    if (refDtcListTable.value) {
      refDtcListTable.value.refresh()
    }
  }

  // Debounced search query
  let searchTimeout = null
  watch(searchQuery, () => {
    clearTimeout(searchTimeout)
    searchTimeout = setTimeout(() => {
      currentPage.value = 1
      refetchData()
    }, 300)
  })

  watch([currentPage, perPage], () => {
    refetchData()
  })

  const fetchTables = (ctx, callback) => {
    isLoading.value = true
    store
      .dispatch('app-dtc/fetchTables', {
        q: searchQuery.value,
        perPage: perPage.value,
        page: currentPage.value
      })
      .then(response => {
        const data = response.data?.data || []
        const total = response.data?.totalItems || 0
        callback(data)
        totalItems.value = total
      })
      .catch(() => {
        toast({
          component: ToastificationContent,
          props: {
            title: i18n.t('Erro ao buscar tabelas DTC'),
            icon: 'AlertTriangleIcon',
            variant: 'danger',
          },
        })
      })
      .finally(() => {
        isLoading.value = false
      })
  }

  return {
    fetchTables,
    tableColumns,
    perPage,
    currentPage,
    totalItems,
    dataMeta,
    perPageOptions,
    searchQuery,
    refDtcListTable,
    refetchData,
    isLoading
  }
}
